var map = {
	"./celery.svg": 13911,
	"./crustacean.svg": 69326,
	"./crustaceans.svg": 70321,
	"./egg.svg": 43964,
	"./fish.svg": 97527,
	"./gluten.svg": 45078,
	"./huevo.svg": 50756,
	"./lupins.svg": 78280,
	"./milk.svg": 60720,
	"./mustard.svg": 59825,
	"./nuts.svg": 94457,
	"./peanut.svg": 8626,
	"./peanuts.svg": 79085,
	"./sesame.svg": 16703,
	"./shellfish.svg": 47683,
	"./soy.svg": 83632,
	"./sulfites.svg": 89544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86862;